<div class="container">
  <button type="button" class="close" mat-button [mat-dialog-close]="true">
    <mat-icon>close</mat-icon>
  </button>
  <div fxLayout="row">
    <h1 mat-dialog-title>Error occurred when merging profiles</h1>
  </div>
  <mat-dialog-content>
    @for (error of data; track error) {
      <p>{{ error }}</p>
    }
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-flat-button color="warn" [mat-dialog-close]="true">Okay</button>
  </mat-dialog-actions>
</div>
